import React from 'react';
import { ClipboardList, Save, ArrowLeft, Search, Printer } from 'lucide-react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const InventoryDetailToolbar = ({ 
    onSave, 
    onBack, 
    isSaving,
    hasChanges,
    details, // Add this prop
    searchTerm,
    onSearchChange 
}) => {

    const generatePDF = () => {
        const doc = new jsPDF();
        
        doc.setFontSize(18);
        doc.text('Physical Inventory Count Sheet', 15, 15);
        doc.setFontSize(12);
        doc.text(`Date: ${new Date().toLocaleDateString()}`, 15, 25);

        const tableData = details.map(item => [
            `${item.proVintage} ${item.proVarietal} ${item.proFanciful} ${item.proWineType} | ${item.proVineyard}`,
            item.previousQuantity.toString(),
            '', 
            ''
        ]);

        doc.autoTable({
            startY: 35,
            head: [['Product', 'Previous', 'Current']],
            body: tableData,
            theme: 'plain',
            styles: {
                fontSize: 9, 
                cellPadding: 3,
                lineWidth: 0.1,
                lineColor: [0, 0, 0]
            },
            columnStyles: {
                0: { cellWidth: 130 },
                1: { cellWidth: 30, halign: 'center' },
                2: { cellWidth: 30, halign: 'center' }
            },
            drawCell: (cell, opts) => {
                // Only draw bottom border of each row
                if (opts.row.index === -1 || cell.section === 'body') {
                    doc.line(
                        cell.x, 
                        cell.y + cell.height,
                        cell.x + cell.width,
                        cell.y + cell.height
                    );
                }
            },
            didDrawPage: (data) => {
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });

        doc.save('inventory-count-sheet.pdf');
    };

    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <ClipboardList size={24} className="me-2" />
                        <h5 className="mb-0">Physical Inventory Count</h5>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group">
                            <span className="input-group-text">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search products..."
                                value={searchTerm}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={generatePDF}
                                title="Print Count Sheet"
                            >
                                <Printer size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onBack}
                                title="Back to Inventory Logs"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button
                                className="btn btn-outline-primary"
                                onClick={onSave}
                                disabled={isSaving || !hasChanges}
                                title={isSaving ? 'Saving...' : 'Save Changes'}
                            >
                                <Save size={18} className="me-2" />
                                {isSaving ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default InventoryDetailToolbar;